import React from 'react';

const EditIcon = () => {
  return (
   <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.2633 5.93908L5.05327 14.6291C4.74327 14.9591 4.44327 15.6091 4.38327 16.0591L4.01327 19.2991C3.88327 20.4691 4.72327 21.2691 5.88327 21.0691L9.10327 20.5191C9.55327 20.4391 10.1833 20.1091 10.4933 19.7691L18.7033 11.0791C20.1233 9.57908 20.7633 7.86908 18.5533 5.77908C16.3533 3.70908 14.6833 4.43908 13.2633 5.93908Z" stroke="#595A5B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.8931 7.38867C12.1027 8.72953 12.7517 9.96281 13.7381 10.8949C14.7245 11.827 15.9925 12.4052 17.3431 12.5387" stroke="#595A5B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  );
};

export default EditIcon;



